import IssuesTable from './IssuesTable';

export default IssuesTable;
